import {doc} from '../../docs.js';
import {gl_sdf} from './scene.js';
import {lazy} from '../lazy.js';
import {extractCode} from '../extract.js';
import {sdf_union} from './sdf.js';
import {hashCode} from "utils/hashCode.js";
import {uuid} from 'uuidv4';
import {float, extract} from '../utils.js';


doc(
    "gl.estimateNormal",
    {
        "sdfs": "list of sdfs",
        "rayOrigin":"",
        "rayDirection":"",
        "ray marched distance":"",
    },
    "Estimates normal for list of sdfs (to be unioned together)",
    () => 1,
    {
        isHot: true,
        inlets: 4
    }
);

export const estimateNormal = (object, rayOrigin, rayDirection, distance) => {
    let id = uuid();
    let functionName = "estimateNormal_" + id.replaceAll('-', '').slice(0,4); 
    return ([scene]) => {
        let {codes, uniforms, functions} = extract(scene, rayOrigin, rayDirection, distance);
 
        functions[functionName] = {
            args: {
                "p": "vec3",
            },
            returnType: "vec3",
            body: `
return normalize(vec3(
        ${scene.code("vec3(p.x + EPSILON, p.y, p.z)")}.x - ${scene.code("vec3(p.x - EPSILON, p.y, p.z)")}.x,
        ${scene.code("vec3(p.x, p.y + EPSILON, p.z)")}.x - ${scene.code("vec3(p.x, p.y - EPSILON, p.z)")}.x,
        ${scene.code("vec3(p.x, p.y, p.z  + EPSILON)")}.x - ${scene.code("vec3(p.x, p.y, p.z - EPSILON)")}.x
    ));
`
        };

        return {
            code: `${functionName}(${codes[1]} + ${codes[2]} * ${codes[3]})`,
            functions,
            uniforms,
        };
    };
};

doc(
    "gl.diffusedLight",
    {
        "normal": "",
        "rayOrigin":"",
        "rayDirection":"",
        "ray marched distance":"",
        "light position":"",
        d1: "",
        d2: "",
    },
    "Calculates light",
    () => 1,
    {
        isHot: true,
        inlets: 7
    }
);
export const gl_diffused_light = (object, rayOrigin, rayDirection, dist, lightPosition, d1, d2) => {
    return lazy(normal => {
        let codes = extractCode(normal, rayOrigin, rayDirection, dist, lightPosition, d1, d2);
        let p = `(${codes[1]} + ${codes[2]} * ${codes[3]})`;
        let lightDirection = `normalize(${codes[4]} - ${p}) * ${float(codes[5])}`;

        return `clamp(dot(${codes[0]}, ${lightDirection}), 0., 1.) * ${float(codes[6])} + ${float(codes[6])}`;

    }, rayOrigin, rayDirection, dist, lightPosition, d1, d2);
};

